import { createSelector } from 'reselect';
import { get, map } from 'lodash';
import { getLandingViewPixel } from '@sparefoot/react-core/utils/tracking';

function mapCityArray(cities) {
	return map(cities, ({ city, uri }) => ({
		label: city,
		uri: `/${uri}`,
	}));
}

export default createSelector(
	({ pages }) => get(pages, 'stateContent', null),
	({ pages }) => get(pages, 'isLoadingState', false),
	(state) => state.app.baseUrl,
	(stateContent, isLoadingState, baseUrl) => {
		// Return loading state when content is not yet available
		if (!stateContent || isLoadingState) {
			return {
				isLoading: true,
				allCities: [],
				title: null,
				body: null,
				contentId: null,
				location: null,
				statusCode: null,
				stateUrl: null,
				drilldownLinks: null,
				meta: {},
				trackingPixel: null,
			};
		}

		return {
			isLoading: false,
			allCities: mapCityArray(stateContent.allCities),
			title: stateContent.title,
			body: stateContent.body,
			contentId: stateContent.contentId,
			location: stateContent.location,
			statusCode: stateContent.statusCode,
			stateUrl: stateContent.stateUrl,
			drilldownLinks: stateContent.drilldownLinks,
			meta: {
				...stateContent.meta,
				canonical: `${baseUrl}/${stateContent.stateUrl}`,
			},
			trackingPixel: getLandingViewPixel({ content: stateContent }),
		};
	},
);
